import { CurriculumAdapter, LevelLite, LevelStatus } from './types';

// Simple test curriculum: "ai"
// Minimal levels and missions purely for wiring tests.
const AI_LEVELS: LevelLite[] = [
  {
    id: '1',
    title: 'AI Level 1: Basics',
    missions: [
      { id: 'm1', text: 'Introduce AI concept' },
      { id: 'm2', text: 'Pick an AI mascot' },
    ],
    sideQuests: [
      { id: 's1', text: 'Fun fact about AI' },
    ],
  },
  {
    id: '2',
    title: 'AI Level 2: Patterns',
    missions: [
      { id: 'm1', text: 'Spot patterns' },
      { id: 'm2', text: 'Group similar items' },
    ],
    sideQuests: [
      { id: 's1', text: 'Pattern hunt' },
    ],
  },
  {
    id: '3',
    title: 'AI Level 3: Decisions',
    missions: [
      { id: 'm1', text: 'Yes/No questions' },
      { id: 'm2', text: 'Build a tiny decision tree' },
    ],
    sideQuests: [
      { id: 's1', text: 'If-then game' },
    ],
  },
];

const indexById = (id: string) => AI_LEVELS.findIndex(l => l.id === id);

const getLevelStatus = (levelId: string, currentLevelId: string, completedIds: string[]): LevelStatus => {
  if (completedIds.includes(levelId)) return 'completed';
  if (levelId === currentLevelId) return 'next';
  return 'upcoming';
};

const getShortLevelName = (title: string) => {
  // Simple shortener: first 12 chars
  return title.length > 12 ? `${title.slice(0, 12)}…` : title;
};

const getMissionActivity = (missionId: string) => {
  // Return a safe, complete placeholder so UI never crashes
  return {
    id: `ai-${missionId}`,
    title: `AI Activity ${missionId}`,
    description: 'Test activity for AI curriculum.',
    image: '',
    link: undefined,
    duration: '5 minutes',
    difficulty: 'Easy',
    materials: [],
    instructions: [],
  } as any;
};

export const aiAdapter: CurriculumAdapter = {
  id: 'ai',
  levels: AI_LEVELS,
  getLevelById: (id: string) => AI_LEVELS.find(l => l.id === id),
  getLevelIndex: (id: string) => Math.max(0, indexById(id)),
  getLevelStatus,
  getShortLevelName,
  getMissionActivity,
};
